import { render, staticRenderFns } from "./select-spu.vue?vue&type=template&id=34612d2d&scoped=true&"
import script from "./select-spu.vue?vue&type=script&lang=js&"
export * from "./select-spu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34612d2d",
  null
  
)

export default component.exports